import { render, staticRenderFns } from "./PageWineApprovedLeft.vue?vue&type=template&id=be4b3ba8"
import script from "./PageWineApprovedLeft.vue?vue&type=script&lang=ts"
export * from "./PageWineApprovedLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports